import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/periodes",
    name: "periods.index",
    component: () => import("@/modules/periods/views/IndexView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
];
